import { loadStripe, Stripe } from '@stripe/stripe-js';

const publishKey =
  process.env.REACT_APP_WEB_URL === 'https://mightymeals.com/'
    ? process.env.REACT_APP_PROD_STRIPE_PUBLISHABLE_KEY
    : process.env.REACT_APP_STAGE_STRIPE_PUBLISHABLE_KEY;

if (!publishKey) {
  throw new Error('Stripe publishable key is not set in environment variables.');
}

const stripePublicKey: string = publishKey;

let stripePromise: Promise<Stripe | null>;

export const getStripe = (): Promise<Stripe | null> => {
  if (!stripePromise) {
    stripePromise = loadStripe(stripePublicKey);
  }
  return stripePromise;
};